import { gql } from '@apollo/client';

export const TicketEventListFields = gql`
  fragment TicketEventListFields on TicketEventView {
    id
    slug
    name
    status
    version
    taxMode
    ticketsEnabled
    coverImageUrl
    startsAt
    timezone
    venueName
    maxAdmissions
    ticketPriceFrom
    publishedAt
    hostUserId
    host {
      id
      storeDetails {
        id
        storeName
      }
    }
    stream {
      id
      name
      slug
      store {
        id
        slug
      }
    }
  }
`;

export const TicketEventDetailsFields = gql`
  fragment TicketEventDetailsFields on TicketEventView {
    ...TicketEventListFields
    description
    streamId
    repeatsEvery
    promotion
    minimumAge
    entryRequirements
    refundPolicy
    termsAndConditions
    venueId
    venueAddress {
      addressLine1
      city
      region
      postalCode
      country
    }
    latitude
    longitude
    endsAt
    doorsOpenAt
    admissionClosesAt
    salesOpenAt
    salesCloseAt
    originalStartsAt
    rescheduledAt
    affiliateEnabled
    affiliateCommissionPercent
    fanPollingEnabled
    league {
      id
      name
    }
    sports {
      id
      name
    }
    hashtags {
      id
      name
    }
    matchups {
      id
    }
  }
  ${TicketEventListFields}
`;

export const TicketTierFields = gql`
  fragment TicketTierFields on TicketTierView {
    id
    label
    description
    price
    capacity
    maxPerOrder
    salesOpenAt
    salesCloseAt
  }
`;

export const TicketingSettingFields = gql`
  fragment TicketingSettingFields on TicketingSetting {
    isLaunched
    isEnabled
    salesEnabled
    transfersEnabled
    gateEnabled
    workersEnabled
    holdSeconds
    paymentResolutionDeadlineSeconds
    transferWindowHours
    minTicketPrice
    maxTicketPrice
    serviceFeePercent
    serviceFeePerTicket
    defaultEventDurationSeconds
    defaultSalesCloseAfterStartSeconds
    maxSalesCloseAfterStartSeconds
  }
`;

export const TicketVenueFields = gql`
  fragment TicketVenueFields on TicketVenueView {
    id
    name
    addressLine1
    city
    region
    postalCode
    country
    timezone
  }
`;

export const TicketEventOrderRowFields = gql`
  fragment TicketEventOrderRowFields on TicketEventOrderRowView {
    orderId
    reference
    status
    kind
    customerName
    email
    admissionCount
    amount
    discountAmount
    serviceFeeAmount
    cardBrand
    cardLast4
    presaleCode
    promocodeCode
    note
    createdAt
    confirmedAt
    buyerUserId
    refundRequestedAt
    refundRequestedBy {
      id
      name
    }
    refundedAt
    refundFailure {
      reason
      failedAt
    }
    lines {
      tierLabel
      admissionCount
      ticketSerials
      amount
    }
  }
`;

/** The same row as TicketEventOrderRowFields plus its event; GraphQL won't spread a fragment across types. */
export const AdminTicketOrderRowFields = gql`
  fragment AdminTicketOrderRowFields on AdminTicketOrderRowView {
    orderId
    reference
    status
    kind
    customerName
    email
    admissionCount
    amount
    discountAmount
    serviceFeeAmount
    cardBrand
    cardLast4
    presaleCode
    promocodeCode
    note
    createdAt
    confirmedAt
    buyerUserId
    refundRequestedAt
    refundRequestedBy {
      id
      name
    }
    refundedAt
    refundFailure {
      reason
      failedAt
    }
    lines {
      tierLabel
      admissionCount
      ticketSerials
      amount
    }
    ticketEvent {
      id
      name
      startsAt
      timezone
    }
  }
`;

export const TicketPresaleCodeFields = gql`
  fragment TicketPresaleCodeFields on TicketPresaleCodeView {
    id
    code
    label
    tierId
    startsAt
    endsAt
    maxUses
    active
  }
`;

export const TicketMatchupFields = gql`
  fragment TicketMatchupFields on Matchup {
    id
    order
    isMainEvent
    category
    rounds
    roundMinutes
    winnerCorner
    competitors {
      id
      corner
      name
      storeId
      store {
        id
        firstName
        lastName
        storeDetails {
          id
          storeName
          avatarURL
        }
      }
    }
  }
`;

export const TicketAffiliateLinkFields = gql`
  fragment TicketAffiliateLinkFields on StreamAffiliateLink {
    id
    code
    status
    clicks
    commissionPercent
  }
`;
